/*
  nw-cart.js — carrinho AJAX + gaveta.

  Antes deste arquivo o tema tinha os ganchos plantados e nenhum codigo:
  [data-nw-cart-count] no header era renderizado no servidor e nunca atualizado, e
  [data-nw-form] na PDP nunca era interceptado — o submit nativo recarregava em /cart.

  Tudo que muda o carrinho re-renderiza a secao inteira pela Section Rendering API,
  entao nao existe formatacao de moeda aqui. O Liquid continua sendo a fonte da verdade.

  Sem JS, os forms continuam funcionando pelo POST nativo. Nao quebra nada.
*/
(function () {
  'use strict';

  var SECAO = 'nw-cart-drawer';
  var raiz = null;
  var ultimoFoco = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function pegaRaiz() {
    if (!raiz || !document.body.contains(raiz)) raiz = $('[data-nw-cart]');
    return raiz;
  }

  /* ---------- abrir / fechar ---------- */

  function abrir() {
    var r = pegaRaiz(); if (!r) return;
    ultimoFoco = document.activeElement;
    r.hidden = false;
    // reflow para a transicao pegar
    void r.offsetWidth;
    r.classList.add('is-aberto');
    document.documentElement.style.overflow = 'hidden';
    var painel = $('.nw-cart__painel', r);
    if (painel) painel.focus();
  }

  function fechar() {
    var r = pegaRaiz(); if (!r) return;
    r.classList.remove('is-aberto');
    document.documentElement.style.overflow = '';
    var esconde = function () { if (!r.classList.contains('is-aberto')) r.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) esconde();
    else setTimeout(esconde, 300);
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  function carregando(on) {
    var r = pegaRaiz(); if (!r) return;
    r.classList.toggle('is-carregando', !!on);
  }

  /* ---------- render ---------- */

  // Troca o miolo da gaveta e devolve a quantidade que a propria secao traz (.nw-cart__n),
  // ou null quando nao da para ler.
  function trocaSecao(html) {
    if (!html) return null;
    var novo = new DOMParser().parseFromString(html, 'text/html');
    var novoRaiz = novo.querySelector('[data-nw-cart]');
    var atual = pegaRaiz();
    if (!novoRaiz || !atual) return null;
    var aberto = atual.classList.contains('is-aberto');
    var estavaHidden = atual.hidden;
    atual.innerHTML = novoRaiz.innerHTML;
    atual.hidden = estavaHidden;
    if (aberto) atual.classList.add('is-aberto');
    var el = novoRaiz.querySelector('.nw-cart__n');
    var n = el ? parseInt(el.textContent, 10) : NaN;
    return isNaN(n) ? null : n;
  }

  function atualizaContador(n) {
    $$('[data-nw-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* ---------- API ---------- */

  function post(url, corpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Erro no carrinho');
        return j;
      });
    });
  }

  // 15/09 (A3): a gaveta so abria depois de um GET /cart.js em serie, feito so para o contador.
  // O /cart/add.js e o /cart/change.js ja devolvem a secao renderizada (e o change.js, o carrinho
  // inteiro), entao o numero sai da propria resposta. O GET fica de reserva.
  function depois(resp) {
    var n = null;
    if (resp && resp.sections && resp.sections[SECAO]) n = trocaSecao(resp.sections[SECAO]);
    if (resp && typeof resp.item_count === 'number') n = resp.item_count;
    if (n !== null) { atualizaContador(n); return Promise.resolve(n); }
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { atualizaContador(c.item_count); return c.item_count; });
  }

  function adicionar(dados) {
    carregando(true);
    dados.sections = SECAO;
    return post('/cart/add.js', dados)
      .then(depois)
      .then(function (c) { abrir(); return c; })
      .catch(function (e) { alerta(e.message); })
      .then(function () { carregando(false); });
  }

  function mudarLinha(linha, qtd) {
    carregando(true);
    return post('/cart/change.js', { line: linha, quantity: qtd, sections: SECAO })
      .then(depois)
      .catch(function (e) { alerta(e.message); })
      .then(function () { carregando(false); });
  }

  function alerta(msg) {
    var r = pegaRaiz();
    if (!r) { window.alert(msg); return; }
    var box = $('.nw-cart__erro', r);
    if (!box) {
      box = document.createElement('p');
      box.className = 'nw-cart__erro';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:12px 22px;padding:10px 12px;border-radius:9px;background:#FBEAE4;color:#8E3A28;font-size:13px;font-weight:700';
      var topo = $('.nw-cart__topo', r);
      if (topo && topo.parentNode) topo.parentNode.insertBefore(box, topo.nextSibling);
    }
    box.textContent = msg;
    abrir();
  }

  /* ---------- eventos ---------- */

  // PDP: intercepta o form. Sem JS ele continua sendo um POST nativo valido.
  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest && ev.target.closest('[data-nw-form]');
    if (!form) return;
    ev.preventDefault();
    var fd = new FormData(form);
    var dados = { items: [{}] };
    var item = dados.items[0];
    item.quantity = 1;
    fd.forEach(function (v, k) {
      if (k === 'id') item.id = v;
      else if (k === 'quantity') item.quantity = parseInt(v, 10) || 1;
      else if (k === 'selling_plan') item.selling_plan = v;
      else if (k.indexOf('properties[') === 0) {
        item.properties = item.properties || {};
        item.properties[k.slice(11, -1)] = v;
      }
    });
    if (!item.id) { form.submit(); return; }
    adicionar(dados);
  });

  // Cards de colecao / home: botao com data-nw-add="<variant id>"
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t.closest) return;

    var add = t.closest('[data-nw-add]');
    if (add) {
      ev.preventDefault();
      ev.stopPropagation();               // o card inteiro e um <a>: nao deixa navegar
      var id = add.getAttribute('data-nw-add');
      if (id) adicionar({ items: [{ id: id, quantity: 1 }] });
      return;
    }

    if (t.closest('[data-nw-cart-fechar]')) { ev.preventDefault(); fechar(); return; }
    if (t.closest('[data-nw-cart-abrir]'))  { ev.preventDefault(); abrir();  return; }

    var mais = t.closest('[data-nw-qtd-mais]');
    if (mais) {
      var lm = parseInt(mais.getAttribute('data-nw-qtd-mais'), 10);
      var elm = mais.closest('.nw-cart__item');
      var vm = elm ? parseInt($('[data-nw-qtd-val]', elm).textContent, 10) : 1;
      mudarLinha(lm, vm + 1); return;
    }
    var menos = t.closest('[data-nw-qtd-menos]');
    if (menos) {
      var ln = parseInt(menos.getAttribute('data-nw-qtd-menos'), 10);
      var eln = menos.closest('.nw-cart__item');
      var vn = eln ? parseInt($('[data-nw-qtd-val]', eln).textContent, 10) : 1;
      mudarLinha(ln, Math.max(0, vn - 1)); return;
    }
    var rem = t.closest('[data-nw-remover]');
    if (rem) { mudarLinha(parseInt(rem.getAttribute('data-nw-remover'), 10), 0); return; }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    var r = pegaRaiz();
    if (r && r.classList.contains('is-aberto')) fechar();
  });

  // contador certo em navegacao com bfcache
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { atualizaContador(c.item_count); })
      .catch(function () {});
  });
})();
